import {
    handConstants,
    keyConstants,
    librariesConstants,
    licensesConstants, prorateConstants,
    qrCodeLogin,
    uploadConstants,
    userConstants,
} from '../_reducers'
import {history} from '../../_history'
import api from '../../axios'
import {getPath} from '../../axios/helpers'
import {fetchPreferences} from '../slices/Preferences/preferences'
import {viewerConstants} from '../_reducers/viewer'
import {
    setAllPositions,
    setEffStack,
    setGameLibrary,
    setGameSpotId,
    setPlayersArrFromLibs,
    setPlayersMode,
    setSpotName,
} from '../slices/trainerSettings'
import Cookies from 'universal-cookie'
import {setStartQuery} from '../slices/trainer'
import {STATUS} from '../../helpers/constants'
import {getNodeInfo} from './asyncActions/Viewer/get_strategy'
import uploadControl from "../../Upload/UploadControl";

export const userActions = {
    login,
    logout,
    getNodeInfo,
    getHandByRawText,
    resetRawHandText,
    getHand,
    getHandList,
    getTaskList,
    getLibraries,
    getLicenses,
    cancelLicense,
    uncancelLicense,
    uploadHandHistory,
    updateStatus,
    newUpload,
    applyLicenseKey,
    newApplyKey,
    openInstaHand,
    getHandReport,
    setBoard,
    setRunoutDisplayMode,
    setHandLineResponse,
    setRunOutActionFilter,
    setRunOutActionFilterApplied,
    setSelectedRowIndex,
    setSizingsStructureData,
    qrGenerate,
    qrCheck,
    openInstaResult,
    getLibrariesWithoutAuth,
    upgradeSubscription,
    getProrateData
}

function setSizingsStructureData(sizings) {
    return (dispatch) => {
        dispatch({
            type: viewerConstants.SET_VIEWER_SIZINGS,
            payload: sizings,
        })
    }
}

export function setSelectedRowIndex(id) {
    return (dispatch) => {
        dispatch({
            type: handConstants.SET_SELECTED_ROW_ID,
            payload: id,
        })
    }
}

export const removeErrorNotification = (error) => ({type: userConstants.LOGIN_FAILURE, error})

function setBoard(globalBoard) {
    return (dispatch) => {
        dispatch({
            type: viewerConstants.SET_BOARD_CARD,
            payload: globalBoard,
        })
    }
}

const cookies = new Cookies()

function setRunOutActionFilter(filter) {
    return (dispatch) => {
        dispatch({
            type: viewerConstants.SET_RUNOUT_ACTION_FILTER,
            payload: filter,
        })
    }
}

function setRunoutDisplayMode(mode) {
    return (dispatch) => {
        dispatch({
            type: viewerConstants.SET_RUNOUT_DISPLAY_MODE,
            payload: mode,
        })
    }
}

function setRunOutActionFilterApplied(applied) {
    return (dispatch) => {
        dispatch({
            type: viewerConstants.SET_RUNOUT_ACTION_FILTER_APPLIED,
            payload: applied,
        })
    }
}

function login(username, password) {
    return (dispatch) => {
        dispatch(request({username}))

        api.login({username, password}).then(
            async (user) => {
                dispatch(success(user)) // set user
                dispatch(getLibraries()) // update libraries
                await dispatch(fetchPreferences())

                cookies.set('isAuthorization', 'true', {path: '/', domain: 'gtobase.com'})
            },
            (error) => {
                dispatch(failure(error.response.data))
            }
        )
    }

    function request(user) {
        return {type: userConstants.LOGIN_REQUEST, user}
    }

    function success(user) {
        return {type: userConstants.LOGIN_SUCCESS, user}
    }

    function failure(error) {
        return {type: userConstants.LOGIN_FAILURE, error}
    }
}

function logout() {
    api.logout()
    history.push('/')
    cookies.set('isAuthorization', 'false', {path: '/', domain: 'gtobase.com'})

    return {type: userConstants.LOGOUT}
}

/**
 * This function login with QR CODE
 **/

function qrGenerate() {
    return async (dispatch) => {
        function success(code) {
            return {type: qrCodeLogin.QR_GENERATE_SUCCESS, code}
        }

        await api.post('qr_generate', null).then(({data}) => dispatch(success(data.code)))
    }
}

function qrCheck(code) {
    return async (dispatch) => {
        function success(result) {
            return {type: qrCodeLogin.QR_CHECK, result}
        }

        await api.post('gr_check', {qr_code: code}).then(({data}) => {
            dispatch(success(data.status))

            if (data.status === STATUS.SUCCESS) {
                localStorage.setItem('user', JSON.stringify(data.auth_data))
                location.reload()
            }

            if (data.status === STATUS.STOP) {
                dispatch(qrGenerate())
            }
        })
    }
}

/**
 * This function updates status of hand tasks
 **/
function updateStatus(taskId, status) {
    return (dispatch) => {
        dispatch(request()) // set request state

        const url = `update_task_status?job_id=${taskId}&to_status=${status}`
        api.get(url).then(() => dispatch(getTaskList()))
    }

    function request() {
        return {type: uploadConstants.UPLOAD_TASK_REQUEST}
    }
}

/**
 * Action function for retrieving licences
 **/
function getLicenses() {
    return (dispatch) => {
        dispatch(request()) // set request state
        const url = 'get_licenses'
        api.get(url).then(({data}) => dispatch(success(data)))
    }

    function request() {
        return {type: licensesConstants.LICENSES_REQUEST}
    }

    function success(licensesResponse) {
        return {type: licensesConstants.LICENSES_SUCCESS, licensesResponse}
    }
}

/**
 *This function lists user licenses
 **/
function getInstaLimits() {
    return (dispatch) => {
        dispatch(request()) // set request state
        const url = 'get_raw_hand_limit'
        api.get(url).then(({data}) => dispatch(success(data)))
    }

    function request() {
        return {type: handConstants.HAND_RAW_LIMIT_REQUEST}
    }

    function success(rawHandLimitResponse) {
        return {type: handConstants.HAND_RAW_LIMIT_SUCCESS, rawHandLimitResponse}
    }
}

function openInstaHand() {
    return (dispatch) => {
        dispatch(open())
        dispatch(getInstaLimits())
    }

    function open() {
        return {type: handConstants.HAND_RAW_SHOW}
    }
}

function openInstaResult() {
    return (dispatch) => dispatch({type: handConstants.HAND_RAW_SHOW})
}

/**
 *This function upgrade license by subscription ID
 **/

function upgradeSubscription(subscriptionId, priceId) {
    return (dispatch) => {
        const url = "upgradeSubscription"
        const payload = {
            "sub_id": subscriptionId,
            "price_id": priceId
        }

        api.post(url, payload).then(() => dispatch(getLicenses()))
    }
}

/**
 * Upgrade subscription using new price ID
 */
function upgradeSubscriptionStripe(){
    return
}


/**
 * Preview prorate information
 */
function getProrateData(subscriptionId, priceId) {
    return (dispatch) => {
        // get result
        const url = `previewUpdateOption?subscription_id=${subscriptionId}&price_id=${priceId}`
        const payload = {
            'sub_id': subscriptionId,
            'price_id': priceId
        }
        api.post(url, payload).then((data) => dispatch({type: prorateConstants.PRORATE_SUCCESS, data}))
    }
}


/**
 *This function cancel license by subscription ID
 **/
function cancelLicense(subscriptionID) {

    return (dispatch) => {
        dispatch(request())
        const url = `cancelSubscription?subscription_id=${subscriptionID}`
        api.get(url).then(() => dispatch(getLicenses()))
    }

    function request() {
        return {type: licensesConstants.LICENSES_REQUEST}
    }
}

/**
 *This function cancel license by subscription ID
 **/
function uncancelLicense(subscriptionID) {
    return (dispatch) => {
        dispatch(request()) // set request state

        const url = `resumeSubscription?subscription_id=${subscriptionID}`

        api.get(url).then(() => dispatch(getLicenses()))
    }

    function request() {
        return {type: licensesConstants.LICENSES_REQUEST}
    }
}

/**
 *This function returns list of libraries available for user
 **/
export function getLibraries(isQuery = false) {
    return (dispatch) => {
        dispatch(request()) // set request state

        const url = 'get_libraries'

        api.get(url).then(({data}) => {
            dispatch(success(data))
            const freeLib = data.libraries.find((lib) => lib.is_free)
            const freeLibSpot = freeLib.spots[0]
            if (!isQuery) {
                dispatch(setGameLibrary(freeLib.library_name))
                dispatch(setSpotName(freeLibSpot.spot))
                dispatch(setGameSpotId(freeLibSpot.spot_id))
                dispatch(setEffStack(freeLibSpot.eff_stacks[0]))
                dispatch(setStartQuery(freeLibSpot.eff_stacks[0], 0))
                dispatch(setAllPositions(freeLibSpot.all_positions))
                dispatch(setPlayersMode('RANDOM'))
            }

            dispatch(setPlayersArrFromLibs(trainerPositions(data)))
        })
    }

    function request() {
        return {type: librariesConstants.LIBRARIES_REQUEST}
    }

    function success(librariesResponse) {
        return {type: librariesConstants.LIBRARIES_SUCCESS, librariesResponse}
    }

    function trainerPositions(librariesResponse) {
        const obj = {}
        librariesResponse &&
        librariesResponse.libraries.map((el) => el.spots.map((s) => (obj[s.spot.replace(/\s/g, '')] = s.spot_positions)))

        return obj
    }
}

export function getLibrariesWithoutAuth() {
    return (dispatch) => {
        dispatch(request()) // set request state
        const url = 'get_libraries_no_auth'
        api.get(url).then(({data}) => {
            dispatch(success(data))
        })
    }

    function request() {
        return {type: librariesConstants.LIBRARIES_REQUEST}
    }

    function success(librariesResponse) {
        return {type: librariesConstants.LIBRARIES_SUCCESS, librariesResponse}
    }
}

/**
 *This function returns single hand
 **/
export function getHand(handId, source) {
    return (dispatch, getState) => {
        dispatch(request()) // set request state
        const url = source !== 'trainer' ? `get_hand?hid=${handId}&source=${source}` : `get_trainer_hand?hid=${handId}`
        api.get(url).then(({data}) => dispatch(success(data)))
    }

    function request() {
        return {type: handConstants.HAND_SINGLE_REQUEST}
    }

    function success(singleHandResponse) {
        return {type: handConstants.HAND_SINGLE_SUCCESS, singleHandResponse, handId}
    }
}

export const setSelectedHand = (handId) => (dispatch) => {
    dispatch({type: handConstants.SELECT_HAND, handId})
}

export const setStacks = (spotId, source) => (dispatch, getState) => {
    const librariesResponse = getState().libs && getState().libs.librariesResponse

    if (!librariesResponse) {
        return
    }

    const maxStackName = source === 'upload' || spotId.includes(111) ? 'parse_max_stack' : 'max_stack'
    const minStackName = source === 'upload' || spotId.includes(111) ? 'parse_min_stack' : 'min_stack'

    // for many spots
    const getMinStack = (spotId) => {
        return (
            librariesResponse &&
            Number(spotId) &&
            librariesResponse.libraries
                .map((item) => item.spots)
                .flat()
                .find((item) => item.spot_id === Number(spotId))[minStackName]
        )
    }

    const getMaxStack = (spotId) => {
        return (
            librariesResponse &&
            Number(spotId) &&
            librariesResponse.libraries
                .map((item) => item.spots)
                .flat()
                .find((item) => item.spot_id === Number(spotId))[maxStackName]
        )
    }

    if (spotId.length > 1) {
        const minStacks = spotId.map((id) => getMinStack(id))
        const maxStacks = spotId.map((id) => getMaxStack(id))

        dispatch({
            type: handConstants.SET_HAND_STACKS,
            minStack: Math.min(...minStacks),
            maxStack: Math.max(...maxStacks),
        })
    } else {
        dispatch({
            type: handConstants.SET_HAND_STACKS,
            minStack: getMinStack(spotId),
            maxStack: getMaxStack(spotId),
        })
    }
}

export const removeSingleHand = (id, source) => async () => {
    const url = source !== 'trainer' ? `delete_hand?hand_id=${id}` : `delete_trainer_hand?hand_id=${id}`

    try {
        await api.get(url)
    } catch (error) {
        console.log('ERROR', error)
    }
}

/**
 *This function returns hand list by filter
 **/
function getHandList(json_filter, json_sort, offset, limit) {
    // change filter ev based on filter ev enabled option
    const isEvFilter = json_filter.filterEV
    const evVal = isEvFilter ? json_filter.ev : null

    const {
        villainArray,
        heroArray,
        heroAliases,
        villainAliases,
        playerNames,
        playerAliases,
        againstVillains,
        againstVillainAliases,
        source,
        is_hero,
    } = json_filter

    const isTrainer = source === 'trainer'

    const custom_filter = {
        ...json_filter,
        is_hero: isTrainer ? true : is_hero,
        ev: evVal,
        heroArray: [...new Set(heroArray?.concat(heroAliases.reduce((acc, item) => acc.concat(item.aliases), [])))],
        villainArray: [
            ...new Set(villainArray?.concat(villainAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
        ],
        playerNames: [...new Set(playerNames?.concat(playerAliases.reduce((acc, item) => acc.concat(item.aliases), [])))],
        againstVillains: [
            ...new Set(againstVillains?.concat(againstVillainAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
        ],
    }

    return async (dispatch) => {
        function request() {
            return {type: handConstants.HAND_LIST_REQUEST}
        }

        function success(listHandResponse) {
            return {type: handConstants.HAND_LIST_SUCCESS, listHandResponse}
        }

        dispatch(request())

        const requestPayload = {
            json_filter: custom_filter,
            json_sort: json_sort,
            offset: offset,
            limit: limit,
        }

        const url = !isTrainer ? 'get_hand_list' : 'get_trainer_hand_list'

        await api
            .post(url, JSON.stringify(requestPayload), {'Content-Type': 'application/json'})
            .then(({data}) => dispatch(success(data)))
    }
}

export const setHandNote =
    ({id, text, source}) =>
        async (dispatch) => {
            const url = `save_hand_notes`

            try {
                await api.put(url, {id: id, hand_notes: text, source: source})
            } catch (error) {
                console.log('ERROR', error)
            }
        }

/**
 *This function returns report by filter
 **/
function getHandReport(json_filter) {
    return (dispatch) => {
        dispatch(request()) // set request state
        const {
            villainArray,
            heroArray,
            heroAliases,
            villainAliases,
            playerNames,
            playerAliases,
            againstVillains,
            againstVillainAliases,
            spotForReport,
            source,
            is_hero,
        } = json_filter

        const isTrainer = source === 'trainer'
        const url = !isTrainer ? 'get_hand_report' : 'get_trainer_hand_report'
        const requestBody = {
            json_filter: {
                ...json_filter,
                is_hero: isTrainer ? true : is_hero,
                spot: spotForReport,
                heroArray: [...new Set(heroArray?.concat(heroAliases.reduce((acc, item) => acc.concat(item.aliases), [])))],
                villainArray: [
                    ...new Set(villainArray?.concat(villainAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
                ],
                playerNames: [
                    ...new Set(playerNames?.concat(playerAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
                ],
                againstVillains: [
                    ...new Set(
                        againstVillains?.concat(againstVillainAliases.reduce((acc, item) => acc.concat(item.aliases), []))
                    ),
                ],
            },
        }

        api
            .post(url, JSON.stringify(requestBody), {'Content-Type': 'application/json'})
            .then(({data}) => dispatch(success(data)))
    }

    function request() {
        return {type: handConstants.HAND_REPORT_REQUEST}
    }

    function success(handReportResponse) {
        return {type: handConstants.HAND_REPORT_SUCCESS, handReportResponse}
    }
}

/* Hand line*/

function setHandLineResponse(data) {
    return (dispatch) =>
        dispatch({
            type: handConstants.HAND_LINE_SUCCESS,
            payload: data,
        })
}

const setHandLineIsLoading = (data) => (dispatch) => {
    dispatch({
        type: handConstants.HAND_LINE_IS_LOADING,
        payload: data,
    })
}

export const getHandLine =
    ({json_filter, json_sort, json_lines, offset, limit}) =>
        async (dispatch) => {
            // change filter ev based on filter ev enabled option
            const isEvFilter = json_filter.is_error
            const evVal = isEvFilter ? json_filter.ev : null

            const {
                villainArray,
                heroArray,
                heroAliases,
                villainAliases,
                playerNames,
                playerAliases,
                againstVillains,
                againstVillainAliases,
                source,
                is_hero,
            } = json_filter

            const newObj = {...json_filter}
            delete newObj.error_street
            delete newObj.filterEV

            const isTrainer = source === 'trainer'

            const custom_filter = {
                ...newObj,
                is_hero: isTrainer ? true : is_hero,
                ev: evVal,
                heroArray: [...new Set(heroArray?.concat(heroAliases.reduce((acc, item) => acc.concat(item.aliases), [])))],
                villainArray: [
                    ...new Set(villainArray?.concat(villainAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
                ],
                playerNames: [...new Set(playerNames?.concat(playerAliases.reduce((acc, item) => acc.concat(item.aliases), [])))],
                againstVillains: [
                    ...new Set(againstVillains?.concat(againstVillainAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
                ],
            }

            const requestPayload = {
                json_filter: custom_filter,
                json_sort: json_sort,
                json_lines: json_lines,
                offset: offset,
                limit: limit,
            }

            try {
                dispatch({
                    type: handConstants.HAND_LINE_IS_LOADING,
                    payload: true,
                })
                // setHandLineIsLoading(true)

                const url = !isTrainer ? 'get_hand_lines' : 'get_trainer_hand_lines'

                const response = await api.post(url, JSON.stringify(requestPayload), {
                    'Content-Type': 'application/json',
                })

                dispatch({
                    type: handConstants.HAND_LINE_SUCCESS,
                    payload: response.data,
                })

                // setHandLineResponse(response.data)

                dispatch({
                    type: handConstants.HAND_LINE_IS_LOADING,
                    payload: false,
                })

                // setHandLineIsLoading(false)
            } catch (e) {
                console.log('ERROR', e.message)
                dispatch({
                    type: handConstants.HAND_LINE_IS_LOADING,
                    payload: false,
                })

                // setHandLineIsLoading(true)
            }
        }

export const getHandLinesStats = ({json_filter, json_sort, json_stats_filter, offset, limit}) => {
    const {
        gMinTimeStamp,
        gMaxTimeStamp,
        status,
        stack,
        line,
        buyIn,
        spot,
        room,
        source,
        is_hero,
        heroPos,
        villainPos,
        heroArray,
        heroAliases,
        villainArray,
        villainAliases,
        playerNames,
        playerAliases,
        againstVillains,
        againstVillainAliases,
        playerPositions,
        playerHands,
        playerHandsCount,
    } = json_filter

    const isTrainer = source === 'trainer'

    const updatedRoom = Array.isArray(room) && room.length > 0 ? room[0] : null
    const updatedVillainArray = [
        ...new Set(villainArray?.concat(villainAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
    ]
    const updatedHeroArray = [
        ...new Set(heroArray?.concat(heroAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
    ]
    const updatedPlayerNames = [
        ...new Set(playerNames?.concat(playerAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
    ]
    const updatedAgainstVillains = [
        ...new Set(againstVillains?.concat(againstVillainAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
    ]
    const updated_json_filter = {
        gMinTimeStamp,
        gMaxTimeStamp,
        status,
        stack,
        line,
        buyIn,
        spot,
        room: updatedRoom,
        source,
        heroPos,
        villainPos,
        heroArray: updatedHeroArray,
        villainArray: updatedVillainArray,
        villainAliases,
        heroAliases,
        playerPositions,
        playerHands,
        playerHandsCount,
        playerAliases,
        playerNames: updatedPlayerNames,
        againstVillainAliases,
        againstVillains: updatedAgainstVillains,
    }

    const updated_json_stats_filter = {
        ...json_stats_filter,
        player_name: updatedPlayerNames,
        is_hero: isTrainer ? true : is_hero,
        position: playerPositions,
    }

    return async (dispatch) => {
        function request() {
            return {type: handConstants.HAND_LINES_STATS_REQUEST}
        }

        function success(listHandLinesStatsResponse) {
            return {type: handConstants.HAND_LINES_STATS_SUCCESS, listHandLinesStatsResponse}
        }

        dispatch(request())

        const requestPayload = {
            json_filter: updated_json_filter,
            json_sort: json_sort,
            json_stats_filter: updated_json_stats_filter,
            offset: offset,
            limit: limit,
        }

        const url = !isTrainer ? 'get_hand_lines_stats' : 'get_trainer_hand_lines_stats'

        await api
            .post(url, JSON.stringify(requestPayload), {
                'Content-Type': 'application/json',
            })
            .then(({data}) => dispatch(success(data)))
    }
}

export const getHandLinesStatsForPlayers = ({
                                                json_filter,
                                                json_sort,
                                                json_lines,
                                                json_stats_filter,
                                                offset,
                                                limit,
                                            }) => {
    const {
        gMinTimeStamp,
        gMaxTimeStamp,
        status,
        stack,
        buyIn,
        player_subs,
        line,
        jobId,
        spot,
        room,
        source,
        hero,
        playerNames,
        playerAliases,
        againstVillains,
        againstVillainAliases,
        playerPositions,
        playerHands,
        playerHandsCount,
        is_names,
        is_alias,
        is_hero_only,
    } = json_filter
    const {combo, draw, action} = json_lines

    const updatedPlayerNames = [
        ...new Set(playerNames?.concat(playerAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
    ]
    const updatedAgainstVillains = [
        ...new Set(againstVillains?.concat(againstVillainAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
    ]
    const updatedRoom = Array.isArray(room) && room.length > 0 ? room[0] : null

    const updated_json_filter = {
        gMinTimeStamp,
        gMaxTimeStamp,
        status,
        stack,
        buyIn,
        player_subs,
        line,
        jobId,
        spot,
        room: updatedRoom,
        source,
        is_hero: hero,
        playerPositions,
        playerHands,
        playerHandsCount,
        playerNames: updatedPlayerNames,
        againstVillains: updatedAgainstVillains,
        /** combo,draw,action - FROM JSON LINES **/
        combo,
        draw,
        action,
    }

    const updated_json_stats_filter = {
        ...json_stats_filter,
        is_hero: hero,
        position: playerPositions,
        // player_name: updatedPlayerNames,
        /** filters for displayed **/
        is_names: is_names ? null : false,
        is_alias: is_alias ? null : false,
        is_hero_only: is_hero_only ? null : false,
    }

    return async (dispatch) => {
        function request() {
            return {type: handConstants.HAND_LINES_STATS_FOR_PLAYERS_REQUEST}
        }

        function success(listHandLinesStatsForPlayersResponse) {
            return {type: handConstants.HAND_LINES_STATS_FOR_PLAYERS_SUCCESS, listHandLinesStatsForPlayersResponse}
        }

        dispatch(request())

        const requestPayload = {
            json_filter: updated_json_filter,
            json_sort: json_sort,
            json_stats_filter: updated_json_stats_filter,
            offset: offset,
            limit: limit,
        }

        const url = 'get_hand_lines_stats_for_players'

        await api
            .post(url, JSON.stringify(requestPayload), {
                'Content-Type': 'application/json',
            })
            .then(({data}) => dispatch(success(data)))
    }
}

export const getHandMistakeStats = ({json_filter, json_stats_filter, json_sort, offset, limit, user_id}) => {
    const {
        gMinTimeStamp,
        gMaxTimeStamp,
        status,
        stack,
        buyIn,
        spot,
        room,
        source,
        playerNames,
        playerAliases,
        jobId,
        line,
        hero,
        playerPositions,
        playerHands,
        playerHandsCount,
        postflop_type,

        is_names,
        is_alias,
        is_hero_only,
    } = json_filter

    const updatedPlayerNames = [
        ...new Set(playerNames?.concat(playerAliases.reduce((acc, item) => acc.concat(item.aliases), []))),
    ]
    const updatedRoom = Array.isArray(room) && room.length > 0 ? room[0] : null

    const updated_json_filter = {
        gMinTimeStamp,
        gMaxTimeStamp,
        status,
        stack,
        buyIn,
        spot,
        room: updatedRoom,
        source,
        is_hero: hero,
        line,
        playerPositions,
        playerNames: updatedPlayerNames,
        playerHands,
        playerHandsCount,
        postflop_type,
        jobId,
    }

    const updated_json_stats_filter = {
        touch_threashold: json_stats_filter.touch_threashold,
        is_hero: hero,
        position: playerPositions,
        /** filters for displayed **/
        is_names: is_names ? null : false,
        is_alias: is_alias ? null : false,
        is_hero_only: is_hero_only ? null : false,
    }

    return async (dispatch) => {
        function request() {
            return {type: handConstants.HAND_MISTAKE_STATS_REQUEST}
        }

        function success(listHandMistakeStatsResponse) {
            return {type: handConstants.HAND_MISTAKE_STATS_SUCCESS, listHandMistakeStatsResponse}
        }

        dispatch(request())

        const requestPayload = {
            json_filter: updated_json_filter,
            json_stats_filter: updated_json_stats_filter,
            json_sort: json_sort,
            offset: offset,
            limit: limit,
            user_id: null,
        }

        const url = 'hand_mistake_stats'

        await api
            .post(url, JSON.stringify(requestPayload), {
                'Content-Type': 'application/json',
            })
            .then(({data}) => dispatch(success(data)))
    }
}

/**
 *This request is to get analytical information
 *from raw text data
 **/
function getHandByRawText(t) {
    return (dispatch) => {
        dispatch(request()) // set request state

        const url = 'get_raw_hand'
        const hand = {
            raw_hand: t,
        }

        api.post(url, JSON.stringify(hand), {'Content-Type': 'application/json'}).then(({data}) => {
            dispatch(success(data))
            dispatch(getInstaLimits())
        })
    }

    function request() {
        return {type: handConstants.HAND_RAW_REQUEST}
    }

    function success(rawHandResponse) {
        return {type: handConstants.HAND_RAW_SUCCESS, rawHandResponse}
    }
}

/**
 Send license key and return result:
 >> text of error
 >> license added
 */
function applyLicenseKey(key) {
    return (dispatch) => {
        dispatch(request()) // set request state

        const url = 'apply_license_key'
        const hand = {
            key,
        }

        api.post(url, JSON.stringify(hand)).then(({data}) => {
            dispatch(success(data))
            dispatch(getLibraries())
        })
    }

    function request() {
        return {type: keyConstants.APPLY_KEY_REQUEST}
    }

    function success(applyKeyResponse) {
        return {type: keyConstants.APPLY_KEY_SUCCESS, applyKeyResponse: {...applyKeyResponse, key}}
    }
}

/**
 *This function reset info in insta hand controller
 **/
function resetRawHandText() {
    return (dispatch) => {
        dispatch(success(null))
    }

    function success(rawHandResponse) {
        return {type: handConstants.HAND_RAW_SUCCESS, rawHandResponse}
    }
}

/**
 * UploadControl files to DB
 * t - form data
 **/
function uploadHandHistory(t) {
    let processedRows = 0

    return (dispatch) => {
        const xhr = new XMLHttpRequest()

        dispatch(request(null, xhr)) // set request state

        xhr.timeout = 1000 * 60 * 30 // should be 20 minutes

        const user = JSON.parse(localStorage.getItem('user'))

        if (user && user.access_token) {
            xhr.open('POST', getPath('upload'))
            xhr.setRequestHeader('Authorization', `Bearer ${user.access_token}`)

            // upload progress
            xhr.upload.addEventListener('loadstart', (data) => {
                dispatch(loadRequest(data))
            });
            xhr.upload.addEventListener('progress', (data) => {
                dispatch(loadRequest(data))
            });
            xhr.upload.addEventListener('loadend', (data) => {
                dispatch(loadRequest(null))
                dispatch(loadCompleted())
            });

            // processing data
            xhr.addEventListener('progress', (data) => {
                const parsed = data.target.response.split('\n')

                parsed.splice(0, processedRows)
                parsed.pop()
                parsed.forEach((element) => {
                    try {
                        dispatch(request(JSON.parse(element)))
                        processedRows++
                    } catch (err) {
                        console.error(err)
                    }
                })
            })

            xhr.addEventListener('loadend', (data) => {
                const parsed = data.target.response.split('\n')
                const last = JSON.parse(parsed[parsed.length - 2])
                dispatch(success(last))
                dispatch(getTaskList()) // update task list after upload
            })

            xhr.addEventListener('readystatechange', async () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 401) {
                        const res = await api.refreshToken()
                        if (res) {
                            dispatch(uploadHandHistory(t))
                        }
                    }
                }
            })
            xhr.send(t)
        }
    }

    function request(state, xhr) {
        return {type: uploadConstants.UPLOAD_REQUEST, state, xhr}
    }

    function loadRequest(uploadProgress) {
        return {type: uploadConstants.UPLOAD_TASK_LOADING, uploadProgress}
    }

    function loadCompleted() {
        return {type: uploadConstants.UPLOAD_TASK_LOAD_COMPLETE}
    }


    function success(uploadResponse) {
        return {type: uploadConstants.UPLOAD_SUCCESS, uploadResponse}
    }
}

function newUpload() {
    return {type: uploadConstants.NEW_UPLOAD}
}

function newApplyKey() {
    return {type: keyConstants.APPLY_KEY_NEW}
}

/**
 * This request is to get the latest tasks list and their statuses
 **/
function getTaskList() {
    return (dispatch) => {
        dispatch(request()) // set request state

        const url = 'get_task_list'

        api.get(url).then(({data}) => {
            dispatch(success(data))
        })
    }

    function request() {
        return {type: uploadConstants.UPLOAD_TASK_REQUEST}
    }

    function success(response) {
        return {type: uploadConstants.UPLOAD_TASK_SUCCESS, response}
    }
}
